import { BodyText, NavLink } from '@make-software/cspr-design';
import React from 'react';
import RouterLink from '../router-link/router-link';

export const RouterNavLink = ({
  children,
  to,
  disabled,
  onClick,
}: {
  children;
  to?;
  disabled?;
  onClick?;
}) => (
  <RouterLink
    to={to}
    render={(props) => (
      <NavLink
        disabled={disabled}
        {...props}
        href={to}
        onClick={(ev) => {
          if (!(ev.ctrlKey || ev.metaKey || ev.shiftKey)) {
            ev.preventDefault();
            props.onClick && props.onClick();
            onClick && onClick();
          }
        }}
      >
        <BodyText size={3}>{children}</BodyText>
      </NavLink>
    )}
  />
);
